import { faGamepadModern } from "@fortawesome/pro-solid-svg-icons/faGamepadModern";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconGame: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faGamepadModern} />;
};
